import React, { ReactNode, CSSProperties } from "react";

// 1. Reusable style components
export const NoWrap = ({ children }: { children: ReactNode }) => (
    <span style={noWrapStyle}>{children}</span>
);

// 2. Shared style objects
export const noWrapStyle: CSSProperties = {
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
};

export const centeredFlex: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

export const fadedText: CSSProperties = {
    color: "#999",
    fontSize: "0.9em",
};

export const boldLabelStyle = {
  fontWeight: 'bold',
};

export const maxW700 = {
    maxWidth: 700
}
